import Vue, { VNode } from 'vue'
import Component from 'vue-class-component'
import { Observer } from "mobx-vue";
import GlobalStore from '@/store/GlobalStore';

import 'animate.css';

@Observer
@Component({})
export default class Home extends Vue {
  $toast: any;
  
  constructor (props: any) {
    super(props)
  }
  
  state = {
    GlobalStore
  }
  
  async mounted () {
    this.state.GlobalStore.bindToast(this.$toast)
  }
  
  render () {
    return (
      <div id="app">
        <transition
          enter-active-class="animated fadeInLeft"
          leave-active-class="animated fadeOutRight">
          <router-view/>
        </transition>
      </div>
    )
  }
  
}